import React from 'react'
import PropTypes from 'prop-types'
import { Theme } from '@pga/pga-component-library'
import { pathOr } from 'ramda'
import ConfigureWithDefault from './ConfigureWithDefault'
import styled from 'styled-components'
import PlacesLocationInput, { defaultPlacesConfig, elementId } from './PlacesLocationInput'
import { connectConfig } from '../../config'
import { getFilterBy } from './utils'

export const PLACES_INPUT_ID = '#places-location-input'

const LocationFilterContainer = styled.div`
  height: 100%;
  width: 100%;

  #${elementId} {
    ::placeholder {
      color: ${Theme.colors.blueGrey};
      font-family: ${Theme.fonts.Montserrat};
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-control {
    width: 100%;
    height: 100%;
    color: ${Theme.colors.primary};
    font-family: ${Theme.fonts.Montserrat};
  }
`

export class PlacesInput extends React.Component {
  constructor (props) {
    super(props)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleClear = this.handleClear.bind(this)
  }

  handleInputChange ({ lat, lng, value, ...args }) {
    const { type } = args
    const { onSearchStateChange } = this.props
    const filter = getFilterBy(type)
    let options = {}

    if (filter) {
      options = filter({ lat, lng, value, ...args })
    } else {
      options = {
        page: 1,
        configure: {
          ...(lat && lng ? { aroundLatLng: `${lat}, ${lng}` } : {}),
          value
        }
      }
    }

    onSearchStateChange(options)
  }

  handleClear () {
    const { onSearchStateChange } = this.props
    const options = { page: 1, configure: { aroundLatLng: undefined, value: undefined } }
    onSearchStateChange(options)
  }

  render () {
    const { searchState } = this.props
    const { value } = pathOr({}, ['configure'], searchState)
    return (
      <LocationFilterContainer>
        <ConfigureWithDefault {...this.props} />
        <PlacesLocationInput
          {...defaultPlacesConfig}
          onChange={this.handleInputChange}
          onClear={this.handleClear}
          defaultValue={value}
        />
      </LocationFilterContainer>
    )
  }
}

PlacesInput.propTypes = {
  onSearchStateChange: PropTypes.func.isRequired
}

export default connectConfig(PlacesInput)
